// src/components/GuideLayout.jsx
import React from "react";
import { Box, Container } from "@mui/material";
import GuideSidebar from "./SidebarAnchors";

const GuideLayout = ({ sections, children }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
        {sections?.length > 0 && (
          <Box
            sx={{
              width: 200,
              flexShrink: 0,
              position: "sticky",
              top: 80,
              alignSelf: "flex-start",
              display: { xs: "none", md: "block" },
            }}
          >
            <GuideSidebar sections={sections} />
          </Box>
        )}

        <Box sx={{ ml: {xs: 0, md: 4},
      p: {xs: 1, md: 0} }}>
          {children}
        </Box>
      </Box>
    </Container>

  );
};

export default GuideLayout;
